import type { GlucoseManagementIndicatorInsight } from "@tandemdiabetes/sugarmate-api-react-client"
import { useCalculationsContext } from "../CalculationsContext"
import styles from "./Tile.module.scss"
import type { TileProps } from "./TileProps"
import { TileTimeSpan } from "./TileTimeSpan"
import { TileTitle } from "./TileTitle"
import { TileValue } from "./TileValue"
import { usePolyglot } from "src/contexts"
import { round } from "src/utils"

export function GlucoseManagementIndicator(props: TileProps<GlucoseManagementIndicatorInsight>) {
  const {
    insightKey,
    range,
  } = props

  const polyglot = usePolyglot()

  const { glucoseCalculations } = useCalculationsContext()
  const { gmi } = glucoseCalculations[range] || {}

  const value = isNaN(gmi) || gmi === undefined
    ? "--"
    : round(
      gmi,
      1,
    ).toLocaleString(polyglot.locale())

  return (
    <>
      <TileTitle insightKey={insightKey} />
      <TileTimeSpan
        id={`${insightKey}-time-range`}
        range={range}
      />
      <TileValue id={`${insightKey}-value`}>
        {`${value}`}
        <span
          className={styles.valuePercentSymbol}
          id={`${insightKey}-percent`}
        >
          %
        </span>
      </TileValue>
    </>
  )
}
